import {generatePath, Navigate, Outlet, useLocation} from "react-router-dom";
import {FunctionComponent, useMemo} from "react";
import {useUser} from "../../contexts";
import {useGetAccount} from "../../apis/requests/user/getAccount";
import {urls} from "../../routes/urls";
import {LoadingCenter} from "@bounce/shared/ui";
import {isEmpty} from "lodash";
import {useAccountId} from "../../contexts/useAccountId";
import {useIsCampaignExpired} from "./useIsExpiredCampaign";

type OnboardingLayoutProps = {};

const OnboardingLayout: FunctionComponent<OnboardingLayoutProps> = () => {
  const {pathname, search} = useLocation();
  const {isLoadingFeatureFlags, featureFlags} = useUser();
  const accountId = useAccountId();
  const queryParams = new URLSearchParams(search);
  const utm_campaign = queryParams.get("utm_campaign");
  const isCampaignExpired = useIsCampaignExpired({utmCampaign: utm_campaign, featureFlags});
  const {data: account} = useGetAccount({accountId}, {enabled: !!accountId});

  const activePaymentPlan = useMemo(() => {
    if (account) return account.active_payment_plan;
  }, [account]);

  if (isLoadingFeatureFlags || isEmpty(featureFlags)) {
    return <LoadingCenter />;
  }
  if (!accountId) {
    return <Navigate to={urls.accounts.url + search} state={{origin: pathname + search}} />;
  }
  if (isCampaignExpired) {
    return <Navigate to={generatePath(urls.expiredCampaign.url, {accountId})} state={{origin: pathname + search}} />;
  }
  if (activePaymentPlan) {
    return <Navigate to={generatePath(urls.accountDashboard.url, {accountId})} state={{origin: pathname + search}} />;
  }
  return <Outlet />;
};

export default OnboardingLayout;
